// components/startProject/StartProjectForm.jsx
import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "./form.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


export default function StartProjectForm() {
 const {
   register,
   handleSubmit,
   setValue,
   formState: { errors },
 } = useForm({
   defaultValues: {
     language: "English",
     contactPreference: "Email",
   },
 });


  const [loading, setLoading] = React.useState(false);

  const onSubmit = (data) => {
    setLoading(true);

    fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        access_key: "41c2c80f-1527-4cbd-8101-2f4c5dd07683",
        subject: `New Project Lead - ${data.name}`,
        ...data,
      }),
    })
      .then(() => {
        toast.success("Thanks! Our team will contact you within 4 hours.");
        setLoading(false);
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again.");
        setLoading(false);
      });
  };

  return (
    <section className="sp-contact-form" id="start-project-form">
      <div className="sp-contact-container">
        {/* LEFT – TRUST */}
        <div className="sp-contact-info">
          <span className="sp-badge">Start a Conversation</span>

          <h2>
            Tell Us About Your <span>Idea</span>
          </h2>

          <p className="sp-intro">
            Share a few details and our senior project consultant will
            personally review your idea and help you plan the best technical
            approach.
          </p>

          {/* Trust highlights */}
          <ul className="sp-trust-points">
            <li>✔ NDA protected from first conversation</li>
            <li>✔ No obligation or sales pressure</li>
            <li>✔ 100% idea & source code ownership</li>
            <li>✔ Response within 4 business hours</li>
          </ul>

          {/* What happens next */}
          <div className="sp-next-steps">
            <h4>What happens after you submit?</h4>
            <ol>
              <li>We review your idea & requirements</li>
              <li>A project expert contacts you</li>
              <li>Free consultation & roadmap discussion</li>
            </ol>
          </div>

          {/* Credibility line */}
          <div className="sp-credibility">
            <span>Trusted by startups & growing businesses worldwide</span>
          </div>
        </div>

        {/* RIGHT – FORM */}
        <form className="sp-contact-card" onSubmit={handleSubmit(onSubmit)}>
          {/* Row 1 */}
          <div className="sp-form-row">
            <div className="sp-field">
              <label>Full Name</label>
              <input {...register("name", { required: true })} />
            </div>

            <div className="sp-field">
              <label>Work Email</label>
              <input type="email" {...register("email", { required: true })} />
            </div>
          </div>

          {/* Row 2 */}
          <div className="sp-form-row">
            <div className="sp-field">
              <label>Phone / WhatsApp</label>

              <PhoneInput
                country="in"
                enableSearch
                inputClass="sp-phone-input"
                containerClass="sp-phone-container"
                buttonClass="sp-phone-flag-btn"
                dropdownClass="sp-phone-dropdown"
                searchClass="sp-phone-search"
                onChange={(value) =>
                  setValue("phone", value, { shouldValidate: true })
                }
              />
            </div>

            <div className="sp-field">
              <label>Preferred Language</label>
              <select {...register("language")} defaultValue="English">
                <option>English</option>
                <option>Hindi</option>
                <option>Arabic</option>
                <option>French</option>
                <option>Spanish</option>
              </select>
            </div>
          </div>

          {/* Full width */}
          <div className="sp-field">
            <label>Brief Project Idea</label>
            <textarea
              rows="3"
              placeholder="Example: MVP for SaaS product / mobile app idea..."
              {...register("message", { required: true })}
            />
          </div>

          {/* Contact preference */}
          <div className="sp-field">
            <label>Preferred Contact Method</label>
            <select {...register("contactPreference")}>
              <option>Email</option>
              <option>WhatsApp</option>
              <option>Phone Call</option>
            </select>
          </div>

          <button>Talk to a Project Expert</button>

          <p className="sp-form-note">
            Prefer email? <a href="/contact">Contact us</a>
          </p>
        </form>
      </div>
    </section>
  );
}
